<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库单号</label>
            <span class="weui-form-preview__value">{{initData.pi_inoutno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.pi_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据类型</label>
            <span class="weui-form-preview__value" v-if="initData.pi_class === 'PURCIN'">采购入库</span>
            <span class="weui-form-preview__value" v-else>采购退货</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商名称</label>
            <span class="weui-form-preview__value">{{initData.bizname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购员</label>
            <span class="weui-form-preview__value">{{initData.emname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">序号</label>
            <span class="weui-form-preview__value">{{initData.pd_pdno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库数</label>
            <span class="weui-form-preview__value">{{initData.inqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">仓库</label>
            <span class="weui-form-preview__value">{{initData.pd_whname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pd_prodcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.pi_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_netprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_orderprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税率（%）</label>
            <span class="weui-form-preview__value">{{initData.pi_taxrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.taxamount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.nettotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">价税合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.ordertotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">汇率</label>
            <span class="weui-form-preview__value">{{initData.pi_rate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{initData.pd_remark}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>